import { render, staticRenderFns } from "./SubportionCard.vue?vue&type=template&id=3b266e50&scoped=true&"
import script from "./SubportionCard.vue?vue&type=script&lang=js&"
export * from "./SubportionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubportionCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SubportionCard.vue?vue&type=style&index=1&id=3b266e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b266e50",
  null
  
)

export default component.exports